<div class="document-list">
  <h2>Documents</h2>
  @if (downloading) {
    <button mat-flat-button class="document-list__download" disabledInteractive disabled>
      <mat-icon>
        <mat-spinner [diameter]="18" [strokeWidth]="2.2"></mat-spinner>
      </mat-icon>
      Downloading
    </button>
  } @else {
    <button
      mat-flat-button
      class="document-list__download"
      (click)="downloadMultiple()"
      [disabled]="documents.length === 0 || isLoading">
      {{ selectedDocumentIds.length > 0 ? 'Download selected documents' : 'Download all documents' }}
    </button>
  }
  @if (!isLoading) {
    <table>
      <thead>
        <tr>
          <th>
            <mat-checkbox
              (change)="$event ? toggleAllRows() : null"
              [checked]="selection.hasValue() && isAllSelected()"
              [indeterminate]="selection.hasValue() && !isAllSelected()">
            </mat-checkbox>
          </th>
          <th>Type</th>
          <th class="name-column">Name</th>
          <th>Category</th>
          <th>Uploaded by</th>
          <th>Time uploaded</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        @if (documents.length > 0) {
          @for (document of documents; track document.id) {
            <tr>
              <td>
                <mat-checkbox
                  (click)="$event.stopPropagation()"
                  (change)="$event ? selection.toggle(document.id) : null"
                  [checked]="selection.isSelected(document.id)">
                </mat-checkbox>
              </td>
              <td>
                <img [ngSrc]="document.fileType | fileIcon" [alt]="document.fileType" width="20" height="20" />
              </td>
              <td class="name-column">{{ document.fileName }}</td>
              <td>{{ document.category }}</td>
              <td>{{ document.uploadedBy }}</td>
              <td>{{ document.createdAt | date: dateTimeFormat : userTimezone }}</td>
              <td class="document-list__actions">
                <span class="material-symbols-outlined" (click)="download(document)">download</span>
                @if (!isArchived) {
                  <span class="material-symbols-outlined" (click)="delete(document.id)">delete</span>
                }
              </td>
            </tr>
          }
        } @else {
          <tr>
            <td colspan="7" class="document-list__no-documents">No documents uploaded yet</td>
          </tr>
        }
      </tbody>
    </table>
  } @else {
    <app-document-list-skeleton></app-document-list-skeleton>
  }
</div>
